
import React from "react";
import { Link } from "react-router-dom";
import Mycelium from "@/components/icons/Mycelium";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-100 py-8 md:py-10 px-4 mt-auto">
      <div className="container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Mycelium className="h-5 w-5 text-eco-500" strokeWidth={1.5} />
            <span className="font-semibold text-sm md:text-base">Ourcelium</span>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs md:text-sm">
            <Link to="/" className="text-muted-foreground hover:text-eco-500 transition-colors">
              Home
            </Link>
            <Link to="/businesses" className="text-muted-foreground hover:text-eco-500 transition-colors">
              Browse
            </Link>
            <Link to="/events" className="text-muted-foreground hover:text-eco-500 transition-colors">
              Events
            </Link>
            <Link to="/about" className="text-muted-foreground hover:text-eco-500 transition-colors">
              About
            </Link>
          </div>
          
          <div className="text-xs md:text-sm text-muted-foreground">
            &copy; {currentYear} Ourcelium. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
